import React from 'react'
import Routes from './routes/routes'
import 'antd/dist/antd.min.css';
// import "slick-carousel/slick/slick-theme.css";
import "./styles/style.scss"
import "./styles/antd.scss"

function Home() {
  return (
    <div className='app'>
      <Routes />
    </div>
  )
}

export default Home